<!--
create by melody on 2018/11/4
description:上传人员PO接收页面
-->
<template>
	<div>
		<div v-if="isShowPageType === 0">
			<page-header :title="title"></page-header>
			<div class="hdp-uf hdp-uf-dc search-container">
				<div class="hdp-uf hdp-uf-hsb">
					<el-col style="width:30%;">
						<el-row :span="6" :offset="6">
							<div class="hdp-uf" style="width:100%;">
								<div class="hdp-uf hdp-uf-vc" style="width:40%;">{{$t('m.ouName')}}：</div>
								<el-select v-model="searchParam.ouName" filterable clearable>
									<el-option v-for="(item, index) in busEntityList" :key="index" :label="item" :value="item"></el-option>
								</el-select>
							</div>
						</el-row>
					</el-col>
					<el-col :gutter="10" style="width:30%;">
						<el-row :span="6" :offset="6">
							<div class="hdp-uf" style="width:100%;">
								<div class="hdp-uf hdp-uf-vc" style="width:40%;">{{$t('m.paymentPeriod')}}:</div>
								<el-date-picker
									style="width:100%;"
									v-model="searchParam.periodName"
									type="month"
									value-format="yyyy-MM"
									:placeholder="$t('m.chooseDate')">
								</el-date-picker>
							</div>
						</el-row>
					</el-col>
					<el-col :gutter="10" style="width:30%;">
						<el-row :span="12" :offset="6">
							<div class="hdp-uf" style="width:100%;">
								<div class="hdp-uf hdp-uf-vc" style="width:40%;">{{$t('m.leaseItemNumber')}}：</div>
								<el-input v-model="searchParam.leaseItemNumber" clearable></el-input>
							</div>
						</el-row>
					</el-col>
				</div>
				<div class="hdp-uf hdp-uf-hsb">
					<el-col :gutter="10" style="width:30%;">
						<el-row :span="12" :offset="6">
							<div class="hdp-uf" style="width:100%;">
								<div class="hdp-uf hdp-uf-vc" style="width:40%;">{{$t('m.generalLedgerPeriod')}}：</div>
								<el-date-picker
									style="width:100%;"
									v-model="searchParam.accountingPeriod"
									type="month"
									value-format="yyyy-MM"
									:placeholder="$t('m.chooseDate')">
								</el-date-picker>
							</div>
						</el-row>
					</el-col>
                    <el-col :gutter="10" style="width:30%;">
                        <el-row :span="12" :offset="6">
                            <div class="hdp-uf" style="width:100%;">
                                <div class="hdp-uf hdp-uf-vc" style="width:40%;">{{$t('m.enableFlag')}}：</div>
                                <el-select v-model="searchParam.poStatus" clearable>
                                    <el-option :label="$t('m.submitted')" value="Y">
                                    </el-option>
                                    <el-option :label="$t('m.notSubmitted')" value="N">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-row>
                    </el-col>
                    <el-col :gutter="10" style="width:30%;">
                    
                    </el-col>
				</div>
				<div class="hdp-uf hdp-uf-hfe">
					<el-row>
						<!-- <el-button type="primary" icon="el-icon-search" @click="getDemoList()"> 查 询 </el-button> -->
                        <lap-search-btn :searchParam="searchParam" @successMethod="getDemoList()"></lap-search-btn>
					</el-row>
				</div>
			</div>
			<div class="table-container">
				<el-button type="info" plain icon="el-icon-delete" @click="handleDelete('batch')"> {{$t('m.delete')}} </el-button>
				<el-table :data="tableData" @selection-change="handleSelectionChange" @select="handleSelect" @select-all="handleSelect" stripe tooltip-effect="dark" style="width: 100%;margin: 24px 0">
					<el-table-column fixed type="selection" width="35"></el-table-column>
					<el-table-column type="index"></el-table-column>
					<el-table-column :label="$t('m.ouName')" width="250">
						<template slot-scope="scope">{{ scope.row.ouName }}</template>
					</el-table-column>
					<el-table-column prop="periodName" :label="$t('m.paymentPeriod')" width="150"></el-table-column>
					<el-table-column prop="leaseItemNumber" :label="$t('m.leaseItemNumber')" width="250"></el-table-column>
					<el-table-column prop="poNumber" :label="$t('m.poNumber')" width="200"></el-table-column>
					<el-table-column prop="poLineNumber" :label="$t('m.poLineNumber')" width="150"></el-table-column>
					<el-table-column prop="currency" :label="$t('m.orderCurrency')" width="150"></el-table-column>
					<el-table-column prop="poChargeAccount" :label="$t('m.poChargeAccount')" width="250"></el-table-column>
					<el-table-column prop="receiptAmount" :label="$t('m.receiptAmount')" width="150"></el-table-column>
					<el-table-column prop="accountingPeriod" :label="$t('m.generalLedgerPeriod')" width="180"></el-table-column>
					<el-table-column prop="poStatusDesc" :label="$t('m.status')" width="200"></el-table-column>
                    <el-table-column prop="poComment" :label="$t('m.comment')" width="200"></el-table-column>
					<el-table-column :label="$t('m.operation')" align="right" width="150">
					<template slot-scope="scope">
						<el-button type="danger" icon="el-icon-delete" size='mini' plain @click="handleDelete('single', scope.row)"></el-button>
					</template>
				</el-table-column>
				</el-table>
				<div class="hdp-uf">
<!--					<a href="./static/template/PO接收重分类模板.xlsx">-->
<!--						<el-button type="primary" icon="el-icon-download"> {{$t('m.POTemplate')}} </el-button>-->
<!--					</a>-->
					<el-button class="file-btn" type="primary" icon="el-icon-upload2" @click="goToOprateUploadPage('PO')"> {{$t('m.enterUpload')}} </el-button>
					<el-button class="file-btn" type="primary" icon="el-icon-circle-check-outline" @click="POSubmit()" v-bind:disabled="isDisableAction"> {{$t('m.submit')}} </el-button>
				</div>
				<lap-pagination :total="total" :searchParam="searchParam" @successMethod="getDemoList()"></lap-pagination>
			</div>
		</div>
		<OprateUpload :paramsObj="currentDetailObj" @close="oprateUploadClose" v-else-if="isShowPageType === 2"></OprateUpload>

	</div>
</template>
<script>
export default {
	data() {
		return {
			title: {
				firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.OPERATE_MANAGE'),
                thirdTitle: this.$t('m.UPLOAD_PO_RECEIVE')
			},
			searchParam: {
				leaseItemNumber: '',
				ouName: '',
				periodName: '',
				accountingPeriod: '',
                poStatus: '',
                pageSize: 10,
                pageNum: 1,
			},
			tableData: [],
			total: 0,
			isDisableAction: true,
			isShowPageType: 0,
			currentDetailObj: {
				uploadType: 'PO',
				fromPageName: this.$t('m.OPERATE_MANAGE'),
			},
			busEntityList: [],
			deleteDemoIdArr: [],

		}
	},
	methods: {
		handleSelectionChange(val) {
			if(val.length > 0) {
				this.isDisableAction = false
			}else{
				this.isDisableAction = true
			}
		},
		getDemoList() {
			this.$commonFunc.commonRequest('get', '/cost_reclassification/list/condition', 'getPOList', this.searchParam)
			.then(res=>{
				this.tableData = res.obj.list
				this.total = res.obj.total
			})
			.catch(res=>{
				this.$message.error(res.message)
			})
		},
		goToOprateUploadPage (type) {
			this.currentDetailObj.uploadType = type
			this.isShowPageType = 2
		}, 
		oprateUploadClose () {
			this.isShowPageType = 0
		},
		POSubmit() {
			// if(this.deleteDemoIdArr.length > 1) {
			// 	this.$message.info(this.$t('m.chooseSingle'))
            //     return
			// }
            console.log('start to  post')
			this.$commonFunc.commonRequest('get', '/cost_reclassification/submitted2', 'POSubmit', {costReclassificationId: this.deleteDemoIdArr, leaseItemNumber: this.leaseItemNumberArr})
			.then(res=>{
				this.$message.success(this.$t('m.operateSuccess'))
				this.getDemoList()
			})
			.catch(res=>{
				this.$message.error(res.message)
			})
		},
		//处理单选
        handleSelect(row) {
            this.deleteDemoIdArr = []
            this.periodNameArr = []
            this.leaseItemNumberArr = []
            if(row.length) {
                for(var i = 0; i < row.length; i++) {
                    this.deleteDemoIdArr.push(row[i].costReclassificationId)
                    this.periodNameArr.push(row[i].periodName)
                    this.leaseItemNumberArr.push(row[i].leaseItemNumber)
                }
            }

            console.log('row size %s',row.length)
        },
        handleDelete(type,row) {
        	if( type == 'batch' && this.deleteDemoIdArr.length == 0) {
                this.$message.info(this.$t('m.chooseDelete'))
                return 
            }
            this.$confirm(this.$t('m.sureDelete'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            })
            .then(() => {
            	let obj = null
                //单个删除
                if(type == 'single') {
                	obj = {costReclassificationIds: row.costReclassificationId}
                } else {
                	obj = {costReclassificationIds: this.deleteDemoIdArr}
                }
                this.$commonFunc.commonRequest('get', '/cost_reclassification/deleted', 'deletePOReceive', obj)
                .then(res=>{
                	this.$message.success(this.$t('m.deleteSuccess'))
                	this.getDemoList()
                })
               	.catch(res=>{
					this.$message.error(res.message)
				})

            })
        },
        getBusEntity() {
            this.$commonFunc.commonRequest('get', '/config/primaryData/getUserCompanyInfo')
            .then(res=>{
                if(res.obj && res.obj.length) {
                    this.busEntityList = res.obj   
                }
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        }
	},
	async mounted() {
		// this.busEntityList = await this.$commonFunc.getValueSetList(this.$valueSetObj.BUSINESS_ENTITY)
		this.getDemoList()
        this.getBusEntity()
	}
}
</script>
<style scoped>
.search-container {
	background: #ffffff;
	padding: 20px 20px 0 20px;
}
.table-container {
	padding: 24px;
	margin: 32px 0;
	background: #ffffff;
}
.el-row {
	margin-bottom: 20px;
}
.el-col {
	border-radius: 4px;
}
.block {
	text-align: right;
}
.el-form-item .el-form-item__content {
	margin-left: 10px !important;
}
.file-btn {
	margin-left:10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/operate/UploadPOReceive.vue